// Module
var code = "<fieldset> <legend ng-if=\"component.legend\"> {{ component.legend }} <kform-component-tooltip></kform-component-tooltip> </legend> <kform-builder-list component=\"component\" form=\"$ctrl.form\" options=\"$ctrl.options\"></kform-builder-list> </fieldset> ";
// Exports
export default code;